import PropTypes from "prop-types";

import { alignItems, strCode } from "../../../../../consts";
import { metricsConfig } from "../../consts/metricsConfig";
import { t } from "../../../../../services";

import {
  FlexContainers,
  Modal,
  Paragraph2,
  TooltipIcon,
  WrapperContainer
} from "../../../../../components";
import { ReportChart } from "../../../../Campaigns/components/ReportChart/ReportChart";
import { MetricsInfoTooltip } from "../MetricsInfoTooltip/MetricsInfoTooltip";
import { DetailedReportModalWrapper, HorizontalChartWrapper, InfoContainer } from "./styled";

export const DetailedReportModal = ({ data, lastSegmentedDate, active, setActive }) => {
  const extendedMetricsConfig = {
    ...metricsConfig,
    total: {
      id: "total",
      name: strCode.CONNECTED_TITLE
    }
  };

  return (
    <DetailedReportModalWrapper>
      <Modal
        id="detailed-report-modal"
        active={active}
        setActive={setActive}
        title={t(strCode.CONNECTED_USERS_TITLE)}>
        <WrapperContainer Container={FlexContainers.FlexColumnStart} width={600} gap={24}>
          <InfoContainer
            Container={
              lastSegmentedDate ? FlexContainers.FlexRowBetween : FlexContainers.FlexRowEnd
            }
            width={"100%"}>
            {lastSegmentedDate && (
              <Paragraph2>{t(strCode.LAST_SEGMENTED_INFO, { date: lastSegmentedDate })}</Paragraph2>
            )}
            <TooltipIcon tooltipWidth={"330px"}>
              <MetricsInfoTooltip />
            </TooltipIcon>
          </InfoContainer>

          <HorizontalChartWrapper
            Container={FlexContainers.FlexRowCenter}
            alignItems={alignItems.start}
            width={"100%"}
            height={340}>
            <ReportChart
              reportData={data}
              metricsConfig={extendedMetricsConfig}
              metricTotal={extendedMetricsConfig.total.id}
              isColumnLegend
              showCalculatedTotal
              showStatus={false}
            />
          </HorizontalChartWrapper>
        </WrapperContainer>
      </Modal>
    </DetailedReportModalWrapper>
  );
};

DetailedReportModal.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  lastSegmentedDate: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired
};
